/**
 * Added for release 2.41, we replaced the old flag setting "useNewPositionsBlotter2", which was defaulting to false, with a new one:
 * "usePositionsBlotterV2", defaulting to true.
 * This migration simply removes the old setting from user's app config for sanity's sake.
 */
export function removeUseNewPositionsBlotter2(config: any) {
  delete config['useNewPositionsBlotter2'];
}
